var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarkerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.756,
    height: 24.632,
    viewBox: "0 0 18.756 24.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11061",
    "data-name": "Group 11061",
    transform: "translate(-101 -6254.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10999",
    "data-name": "Group 10999",
    transform: "translate(101 6254.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_11711",
    "data-name": "Path 11711",
    transform: "translate(0 0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.399449348449707 23.52903938293457 C 7.26113748550415 21.11857223510742 5.734531402587891 19.11956787109375 4.812179565429688 17.83827972412109 C 2.154679775238037 14.14662075042725 0.7499997019767761 11.2210807800293 0.7499997019767761 9.377930641174316 C 0.7499997019767761 4.620470523834229 4.620469570159912 0.7500004768371582 9.3779296875 0.7500004768371582 C 14.13538932800293 0.7500004768371582 18.005859375 4.620470523834229 18.005859375 9.377930641174316 C 18.005859375 10.71269035339355 17.25833892822266 13.33230018615723 13.69717979431152 18.23211097717285 C 11.99575805664062 20.57309532165527 10.24265670776367 22.60077857971191 9.399449348449707 23.52903938293457 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.3779296875 1.5 C 5.034019470214844 1.5 1.5 5.034021377563477 1.5 9.377930641174316 C 1.5 10.33980083465576 2.009380340576172 12.66105079650879 5.420869827270508 17.40011024475098 C 6.251103401184082 18.55343437194824 7.576862335205078 20.2952823638916 9.405241012573242 22.39898681640625 C 10.33332538604736 21.34030723571777 11.7528133392334 19.63870429992676 13.14807987213135 17.71179008483887 C 16.72218894958496 12.77579021453857 17.255859375 10.37167072296143 17.255859375 9.377930641174316 C 17.255859375 5.034021377563477 13.72183990478516 1.5 9.3779296875 1.5 M 9.3779296875 0 C 14.55721950531006 0 18.755859375 4.198640823364258 18.755859375 9.377930641174316 C 18.755859375 14.53825378417969 9.489182472229004 24.63171768188477 9.378771781921387 24.63171768188477 C 9.378366470336914 24.63171768188477 9.378087043762207 24.63158416748047 9.3779296875 24.63131141662598 C 9.334919929504395 24.55681991577148 0 14.55722045898438 0 9.377930641174316 C 0 4.198640823364258 4.198639869689941 0 9.3779296875 0 Z",
    stroke: "none",
    fill: "#437cf9"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(107 6260.328)",
    fill: "#437cf9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerBlue);
export default __webpack_public_path__ + "static/media/map-marker-blue.032f9bfd9c33708978afe19b0981c57c.svg";
export { ForwardRef as ReactComponent };